<template>
  <v-app id="app">
    <div v-html="headerHtml"></div>

    <v-content>
      <router-view />
    </v-content>

    <div v-html="footerHtml"></div>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  name: "App",
  data() {
    return {
      headerHtml: "",
      footerHtml: ""
    };
  },

  created: function() {
    this.initializeHeader();
    this.initializeFooter();
  },

  methods: {
    initializeHeader() {
      let _this = this;
      axios.get("header.html").then(response => {
        _this.headerHtml = response.data;
      });
    },

    initializeFooter() {
      let _this = this;
      axios.get("footer.html").then(response => {
        _this.footerHtml = response.data;
      });
    }
  }
};
</script>

<style scoped>
#app {
  display: flex;
  flex-direction: column;
}
</style>